import { createFeatureSelector, createSelector } from '@ngrx/store';
import { maintanceFeatureKey, MaintanceState } from './maintance.state';

export const selectMaintanceStateRoot =
  createFeatureSelector<MaintanceState>(maintanceFeatureKey);

export const selectMaintance = createSelector(
  selectMaintanceStateRoot,
  (state) => state.maintance,
);

export const selectLoading = createSelector(
  selectMaintanceStateRoot,
  (state) => state.loading,
);
